import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/config/auth";
import ModeSelection from "@/pages/ModeSelection";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
// Documents
import DocumentsList from "@/pages/documents/DocumentsList";
import DocumentDetail from "@/pages/documents/DocumentDetail";
// Advanced (existing, untouched logic)
import Dashboard from "@/pages/Dashboard";
import NewAssessment from "@/pages/NewAssessment";
import AssessmentResult from "@/pages/AssessmentResult";
import AssessmentList from "@/pages/AssessmentList";
import AdminBenchmarks from "@/pages/AdminBenchmarks";
import MaterialBenchmarks from "@/pages/MaterialBenchmarks";
// Basic (new, parallel)
import BasicDashboard from "@/pages/basic/BasicDashboard";
import BasicNewAssessment from "@/pages/basic/BasicNewAssessment";
import BasicAssessmentList from "@/pages/basic/BasicAssessmentList";
import BasicAssessmentResult from "@/pages/basic/BasicAssessmentResult";
import BasicAdminBenchmarks from "@/pages/basic/BasicAdminBenchmarks";
import BasicMaterialBenchmarks from "@/pages/basic/BasicMaterialBenchmarks";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public landing */}
            <Route path="/" element={<ModeSelection />} />

            {/* Auth */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Documents — auth required, accessible from Basic + Advanced + Landing */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/documents" element={<DocumentsList />} />
              <Route path="/documents/:slug" element={<DocumentDetail />} />
            </Route>

            {/* Advanced PSI — fully gated behind authentication */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/advanced" element={<Dashboard />} />
              <Route path="/advanced/new" element={<NewAssessment />} />
              <Route path="/advanced/assessments" element={<AssessmentList />} />
              <Route path="/advanced/assessments/:id" element={<AssessmentResult />} />
              <Route path="/advanced/benchmarks" element={<AdminBenchmarks />} />
              <Route path="/advanced/material-benchmarks" element={<MaterialBenchmarks />} />
            </Route>

            {/* Basic PSI — public, no auth */}
            <Route element={<Layout />}>
              <Route path="/basic" element={<BasicDashboard />} />
              <Route path="/basic/new" element={<BasicNewAssessment />} />
              <Route path="/basic/assessments" element={<BasicAssessmentList />} />
              <Route path="/basic/assessments/:id" element={<BasicAssessmentResult />} />
              <Route path="/basic/benchmarks" element={<BasicAdminBenchmarks />} />
              <Route path="/basic/material-benchmarks" element={<BasicMaterialBenchmarks />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
